import React, { useLayoutEffect, useRef } from 'react';

import { css } from '@emotion/css';
import { DateTime } from 'luxon';

import { useChatMessageContent } from '@/hooks/useChatMessageContent.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { ChatVisibilityType } from '@/models/ChatModel.ts';
import { Separator } from '@/uiKit/atoms/Separator.tsx';
import { MessageContent } from '@/uiKit/molecules/chat/MessageContent.tsx';

export type MessagesListProps = {
  patientId: string;
  visibility: ChatVisibilityType;
};

export const MessagesList: React.FC<MessagesListProps> = ({
  patientId,
  visibility,
}) => {
  const styles = useStyles(makeStyle);
  const endOfMessageRef = useRef<HTMLDivElement>(null);
  const messages = useChatMessageContent(patientId, visibility);

  useLayoutEffect(() => {
    if (endOfMessageRef?.current) {
      endOfMessageRef.current.scrollIntoView({
        behavior: 'instant',
        block: 'end',
        inline: 'nearest',
      });
    }
  });

  return (
    <div className={styles.container}>
      {messages &&
        messages.map(dailyContent => (
          <>
            <Separator
              key={dailyContent.sentDate.toISO()}
              text={dailyContent.sentDate.toLocaleString(DateTime.DATE_HUGE)}
            />
            {dailyContent.messages.map(message => (
              <MessageContent key={message.id} message={message} />
            ))}
          </>
        ))}
      <div ref={endOfMessageRef} />
    </div>
  );
};

const makeStyle = () => ({
  container: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  }),
});
